export enum TestingOrganizationsStudentMatchStatusEnum {
  MATCHED = "MATCHED",
  PARTIALLY_MATCHED = "PARTIALLY_MATCHED",
  NOT_MATCHED = "NOT_MATCHED",
}
